import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faUserCheck, faBullhorn, faHandshake, faThumbsUp, faTools, faGamepad, faDollarSign, faArrowRight, faDatabase, faRobot, faDollar, faMoneyBill, faUsers, faGift, faVial } from '@fortawesome/free-solid-svg-icons';
import Header from '../../component/layout/header';
import Footer from '../../component/layout/footer';
import Navigate from '../../../../util/Navigate';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PublisherSubmenu from '../../component/section/publishers/PublisherSubmenu';

function PublisherBenefitPage() {

  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';

  return (
    <>
      <Helmet prioritizeSeoTags>
        <meta charSet="utf-8" />
        <title>Revolutionize Game Marketing with Performance-Based Influencer Strategies | Glitch Gaming</title>
        <meta name="description" content="Unlock the power of performance-based influencer marketing for your game. Glitch offers innovative solutions for authenticity, quality content, and optimized platform utilization to maximize game exposure and engage effectively with micro-influencers." />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Revolutionize Game Marketing with Performance-Based Influencer Strategies | Glitch" />
        <meta property="og:description" content="Unlock the power of performance-based influencer marketing for your game. Glitch offers innovative solutions for authenticity, quality content, and optimized platform utilization to maximize game exposure and engage effectively with micro-influencers." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content="https://www.glitch.fun/assets/images/publishers/banner_3.png" />
      </Helmet>
      <Header />
      <div className="container-fluid text-center text-white py-5" style={bannerStyle}>
        <br /><br />
        <h1 style={{ fontSize: "2.5rem" }}>Boost Your Game's Success with <br /><br />Performance-Based Influencer Marketing</h1>
      </div>

      <section className="cta-section mt-5 mb-5">
        <div className="container">
          <div className="cta-wrapper p-4" style={{ backgroundImage: "url(/assets/images/cta/bg.jpg)", borderRadius: '10px' }}>
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="cta-content">
                  <p style={{ fontSize: "1.5rem" }} className="theme-color text-uppercase ls-2">What Is Performance-Based Marketing?</p>
                  <p className="mb-3 lead">Performance-based influencer marketing means you compensate influencers based on the
                    results they deliver—like clicks, installs, or sales—rather than upfront fees.</p>
                  <ul className="lead">
                    <li>Minimize financial risk</li>
                    <li>Maximize return on investment</li>
                    <li>Ensure measurable outcomes</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6 text-end">
                <img src='/assets/images/publishers/performance_based.gif' alt="gamer receiving tips" className="img-fluid rounded shadow border border-white border-2" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container py-5 mb-5">
        <div className="mb-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="ratio ratio-16x9">
                <video className="w-100 rounded shadow" src="/assets/videos/publishers/gaming_influencer_recording.mp4" autoPlay loop muted playsInline></video>
              </div>
            </div>
            <div className="col-md-6">
              <h2 className="mb-4">Creators Will Drive Installs</h2>
              <p className="lead">Collaborate with influencers who genuinely resonate with your game's audience. Benefit
                from:</p>
              <ul className="lead list-unstyled">
                <li>
                  <FontAwesomeIcon icon={faUsers} className="text-info me-2" />
                  Authentic content that drives engagement
                </li>
                <li>
                  <FontAwesomeIcon icon={faChartLine} className="text-warning me-2" />
                  Higher conversion rates with targeted audiences
                </li>
                <li>
                  <FontAwesomeIcon icon={faRobot} className="text-success me-2" />
                  AI-assisted campaign optimization
                </li>
              </ul>
              <form className="contact-form mt-4" id="contact-form" method="POST">
                <div className="form-group w-100 text-center">
                  <Link className="default-button reverse-effect" to={Navigate.publishersOnboardingStep1Page()}><span>Get Started Now</span></Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        <br /><br />

        <div className="mb-5 py-4 px-3 bg-dark text-white rounded mt-2">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="mb-4">Ensuring Quality and Authenticity</h2>
              <p className="lead"><FontAwesomeIcon icon={faBullhorn} className="me-2" /> We use AI combined with your campaign objectives to help influencers create content that aligns your game and that resonate with their audience, producing genuine and high-quality results.</p>
            </div>
            <div className="col-md-6 text-end">
              <img src="/assets/images/publishers/reddit_ai_assist.gif" alt="Quality and Authenticity" className="img-fluid rounded shadow" />
            </div>
          </div>
        </div>
        <br /><br />

        <div className="mb-5 pt-4 text-center bg-light rounded" style={{ backgroundImage: "url(/assets/images/cta/bg.jpg)" }}>
          <h2 className="mb-4">Optimized Platform Utilization</h2>
          <FontAwesomeIcon icon={faChartLine} size="3x" className="mb-3 text-success" />
          <p className="lead">Encouraging strategic platform usage, content creators can craft more impactful and tailored content, maximizing the reach and engagement of your game.</p>
          <img src="/assets/images/publishers/campaign_statistics.gif" alt="Platform Utilization" className="img-fluid rounded shadow border border-white border-2 " />

          <form className="contact-form mt-4" id="contact-form" method="POST">
            <div className="form-group w-100 text-center">
              <Link className="default-button reverse-effect" to={Navigate.publishersOnboardingStep1Page()}><span>Sign Up And Use For Free</span></Link>
            </div>
          </form>
        </div>

        <div className="mb-5 py-4 px-3 bg-dark text-white rounded">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h2 className="mb-4">Transparent Metrics and Rewards</h2>
              <p className="lead">
                <FontAwesomeIcon icon={faHandshake} className="text-primary me-2" />
                Track performance with real-time analytics. Our platform offers:
              </p>
              <ul className="lead">
                <li>Clear visibility into campaign results</li>
                <li>Data-driven decision making</li>
                <li>Fair and transparent influencer compensation</li>
              </ul>
            </div>
            <div className="col-md-4 text-end">
              <img src="/assets/images/publishers/performance_based_1.png" alt="Metrics and Rewards" className="img-fluid rounded shadow" />
            </div>
          </div>
        </div>

        <PublisherSubmenu />

        <div className='pt-5 pb-5 bg-dark text-white text-center rounded' style={{ backgroundImage: "url(/assets/images/video/bg.jpg)" }}>
          <h2 className="text-danger mb-4">Join Glitch for Performance-Based Marketing</h2>
          <p className="lead">Revolutionize your game marketing strategy with Glitch. Embrace a new era of influencer marketing and see the difference in performance and cost.</p>
          <Link to={Navigate.publishersOnboardingStep1Page()} className="btn btn-lg btn-danger text-white">Sign Up Now</Link>
          <p className="lead mt-4">Discover more about the transformative impact of performance-based influencer marketing.</p>
          <a href="https://glitch.ghost.io/how-performance-based-influencer-marketing-improves-games/" target='_blank' className="btn btn-outline-secondary">Read Full Article</a>
        </div>
      </div>
      <Footer />
    </>
  );
}

const bannerStyle = {
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("/assets/images/publishers/banner_3.png")`,
  height: '500px',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fontSize: '2.5rem',
  fontWeight: 'bold',
  textAlign: 'center',
  textShadow: '3px 3px 6px rgba(0, 0, 0, 0.9)'
};

export default PublisherBenefitPage;
